import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/common";
import { AppShell } from "@/components/AppShell";
import AuthPage from "@/pages/AuthPage";
import { ResetPasswordPage, VerifyEmailPage, SupportVerifyPage } from "@/pages/TokenPages";
import ProfilePage from "@/pages/ProfilePage";
import ConnectionsPage from "@/pages/ConnectionsPage";
import ConnectionSpace from "@/pages/ConnectionSpace";
import PersonProfilePage from "@/pages/PersonProfilePage";
import WishlistPage from "@/pages/WishlistPage";
import SettingsPage from "@/pages/SettingsPage";
import AdminPage from "@/pages/AdminPage";
import InvitePage from "@/pages/InvitePage";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <div className="min-h-screen bg-[#070A12]"><Loader label="Opening InfoKeepSake…" /></div>;
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <div className="min-h-screen bg-[#070A12]"><Loader label="Loading…" /></div>;
  if (user) return <Navigate to="/profile" replace />;
  return children;
}

function Shell() {
  return (
    <Protected>
      <AppShell />
    </Protected>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" theme="dark" richColors closeButton />
        <Routes>
          <Route path="/" element={<PublicOnly><AuthPage /></PublicOnly>} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/support/verify" element={<SupportVerifyPage />} />
          <Route path="/invite/:token" element={<InvitePage />} />
          <Route element={<Shell />}>
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/connections" element={<ConnectionsPage />} />
            <Route path="/connections/:id" element={<ConnectionSpace />} />
            <Route path="/connections/:id/profile" element={<PersonProfilePage />} />
            <Route path="/wishlist" element={<WishlistPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/profile" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
